export type Gender = "MALE" | "FEMALE" | "UNKNOWN" | undefined;

export interface AddressProps {
  line1?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
}
export interface FilterProps {
  language?: string;
  gender?: Gender;
}

export enum ProviderStatus {
  Available = "availableNow",
  Busy = "availableSoon",
  Offline = "offline",
  WaitingRoom = "amountWaiting",
}
